module.exports = __webpack_public_path__ + "img/image-thumb-10.283eb3cb.webp";